import React, { useEffect, useState } from 'react';
import { useResusContext } from '../Resus/ResusContext';
import './MedicalProceduresRecommendedValues.css';
import { getHospitalData } from './PerHospitalResusConfig';
import { useTranslation } from 'react-i18next';

interface ProcedureData {
    catheter?: string;
    zonda?: string;
}

interface MedicalProceduresRecommendedValuesProps {
  showTitle?: boolean;
}

const MedicalProceduresRecommendedValues: React.FC<MedicalProceduresRecommendedValuesProps> = ({ showTitle = true }) => {
  const { age, hospital } = useResusContext();
  const [procedureData, setProcedureData] = useState<ProcedureData>({});
  const { t } = useTranslation(['resus']);

  useEffect(() => {
    const airwaysData = getHospitalData(hospital).airways;
    if (age !== null && age !== undefined && airwaysData.dataByAge) {
      const currData = airwaysData.dataByAge.find((data: any) => data.age === age);
      if (currData) {
        setProcedureData(currData);
      }
    } else {
        setProcedureData({});
    }
  }, [age, hospital]);

  return (
    <>
      {showTitle && <h5 className="procedures-title">{t('procedures.recommendedValues')}</h5>}
      <div className="procedures-recommendations">      
        <ul className="procedures-list">
          {procedureData.catheter && <span className="procedure-data">{t('procedures.recommendedCatheterSize')}: {procedureData.catheter}</span>}<br />
          {procedureData.zonda && <span className="procedure-data">{t('procedures.recommendedZondaSize')}: {procedureData.zonda}</span>}
        </ul>
      </div>
    </>
  );
};

export default MedicalProceduresRecommendedValues;